import React, { useContext, useEffect, useState } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import {
  RazorBadgeTwo,
  RazorCopyText,
  RazorDateTime,
  RazorInputField,
  RazorNumberFormat,
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
} from "../../../components/razor-reuse";
import DotActionDropFragment from "../../../components/fragment/actionIconFragment/DotActionDropFragment";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import {
  AddAllToList,
  reactSelectStyleTable,
  rearrangeObjectsByKey,
} from "../../../utils/Helper";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import CurrencyText from "../../../components/fragment/cur-text/CurrencyText";
import { getLedgerOverview, getLedgerRecord } from "../../../redux/ledger";
import { systemRoles } from "../../../utils/roles";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { useNavigate } from "react-router";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import ActionContext from "../../../context/ActionContext";
import Skeleton from "react-loading-skeleton";
import DateRangeComponent from "../../../components/fragment/date-range/DateRangeComponent";
import FilterReusableComp from "../../../components/FilterReusableComp";

export default function LedgerIndex() {
  const actionCtx = useContext(ActionContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currencyView, setCurrencyView] = useState<any>({
    label: "All Currencies",
    value: "",
    donT_send: true,
  });

  const typeOption = [
    { label: "Business Wallet", value: "business_wallet" },
    { label: "Customer Wallet", value: "customer_wallet" },
    { label: "Funding", value: "funding" },
    { label: "All", value: "" },
  ];

  const statusOption = [
    { label: "Pending", value: "pending" },
    { label: "Completed", value: "completed" },
    { label: "Rejected", value: "rejected" },
    { label: "In review", value: "in_review" },
    { label: "All", value: "" },
  ];

  const initialState = {
    page: 1,
    account_type: { label: "All Type", value: "" },
    status: { label: "Status", value: "" },
    date: "",
    search: "",
  };

  const [query, setquery] = useState(initialState);

  const headerList = [
    "reference",
    "date",
    "status",
    "account type",
    "provider",
    "amount",
    "Action",
  ];

  const { loading, ledger_record, ledger_overview } = useSelector(
    (state: RootState) => state?.ledger,
  );
  const { user } = useSelector((state: RootState) => state.auth);
  const { all_currencies_drop } = useSelector(
    (state: RootState) => state.settings,
  );

  // useEffect to check if user has permission to view ledger
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[45]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, [user?.permissions]);

  useEffect(() => {
    const payload = {
      ...query,
      currency: currencyView?.code,
      per_page: actionCtx?.perPage?.label,
      account_type: query.account_type?.value,
      status: query.status?.value,
      "filter[date]": query?.date,
      search: query?.search,
    };
    dispatch(getLedgerRecord(payload) as any);
    dispatch(getLedgerOverview({ currency: currencyView?.code }) as any);
  }, [query, currencyView, actionCtx.perPage]);

  const formatCurrencyValList = (list: any) => {
    const newList = list?.filter(
      (chi: any) => chi?.label !== currencyView?.label,
    );
    // const
    return newList;
  };

  const formatOptionLabelCurrency = ({ label, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <CurrencyText currency={label} text={label} />
        </>
      );
    }
  };

  return (
    <DashboardLayoutMain loading={loading && !ledger_record} title="Ledger">
      <main className="transaction-index-wrap-box-smartsend">
        <TitleBtnFragment
          selectFragment={
            <>
              <RazorInputField
                selectOption={formatCurrencyValList(
                  AddAllToList(all_currencies_drop, "Currencies"),
                )}
                type="select"
                color="black-light"
                className="select-title-wrap"
                value={currencyView}
                onChange={(e: any) => {
                  setCurrencyView(e);
                  setquery(initialState);
                }}
                selectStyles={reactSelectStyleTable}
                formatOptionLabel={formatOptionLabelCurrency}
                placeholder="Filter by Currency"
              />
            </>
          }
          title=" "
          hideBtn
        />

        <div className="grid grid-cols-3 gap-[24px]">
          {/* Business Inflow Card */}
          <div className="bg-white rounded-[12px] px-[20px] py-[18px]">
            <h3 className="text-[14px] font-medium text-gray-600 mb-[12px] flex items-center truncate">
              {currencyView?.id && (
                <CurrencyText
                  currency={currencyView?.code || "ngn"}
                  imgSize="2rem"
                />
              )}
              <span>Business Inflow</span>
              {currencyView?.id && (
                <span className="text-gray-500 capitalize ml-[6px]">
                  {currencyView?.code} Transactions
                </span>
              )}
            </h3>
            {loading ? (
              <Skeleton className="number" width={100} height={50} />
            ) : (
              <p className="text-[40px] font-bold text-black">
                {RazorNumberFormat(ledger_overview?.data?.total_inflow, {
                  hideDecimal: true,
                  hideSymbol: true,
                  numberAbbreviate:
                    String(ledger_overview?.data?.total_inflow)?.length > 5,
                })}
              </p>
            )}
          </div>

          {/* Business Outflow Card */}
          <div className="bg-white rounded-[12px] px-[20px] py-[18px]">
            <h3 className="text-[14px] font-medium text-gray-600 mb-[12px] flex items-center truncate">
              {currencyView?.id && (
                <CurrencyText
                  currency={currencyView?.code || "ngn"}
                  imgSize="2rem"
                />
              )}
              <span>Business Outflow</span>
              {currencyView?.id && (
                <span className="text-gray-500 capitalize ml-[6px]">
                  {currencyView?.code} Transactions
                </span>
              )}
            </h3>
            {loading ? (
              <Skeleton className="number" width={100} height={50} />
            ) : (
              <p className="text-[40px] font-bold text-black">
                {RazorNumberFormat(ledger_overview?.data?.total_outflow, {
                  hideDecimal: true,
                  hideSymbol: true,
                  numberAbbreviate:
                    String(ledger_overview?.data?.total_outflow)?.length > 5,
                })}
              </p>
            )}
          </div>

          {/* Total Transactions Card */}
          <div className="bg-white rounded-[12px] px-[20px] py-[18px]">
            <h3 className="text-[14px] font-medium text-gray-600 mb-[12px] flex items-center truncate">
              {currencyView?.id && (
                <CurrencyText
                  currency={currencyView?.code || "ngn"}
                  imgSize="2rem"
                />
              )}
              <span>Total Transactions</span>
              {currencyView?.id && (
                <span className="text-gray-500 capitalize ml-[6px]">
                  {currencyView?.code} Transactions
                </span>
              )}
            </h3>
            {loading ? (
              <Skeleton className="number" width={100} height={50} />
            ) : (
              <p className="text-[40px] font-bold text-black">
                {RazorNumberFormat(ledger_overview?.data?.total_transactions, {
                  hideDecimal: true,
                  hideSymbol: true,
                  numberAbbreviate:
                    String(ledger_overview?.data?.total_transactions)?.length >
                    5,
                })}
              </p>
            )}
          </div>
        </div>

        <FilterReusableComp
          defaultSelectOne="Account Type"
          className="mb-[15px]"
          selectOneValue={query.account_type}
          selectOneList={typeOption}
          onSelectOne={(param) => {
            console.log(param, "111");
            setquery((prev) => ({ ...prev, account_type: param, page: 1 }));
          }}
          onSearch={(param: any) => {
            setquery((prev) => ({ ...prev, search: param, page: 1 }));
          }}
          selectTwoValue={query.status}
          // formatOptionLabelTwo={formatOptionLabelTwo}
          defaultSelectTwo="Status"
          selectTwoList={statusOption}
          onSelectTwo={(param) => {
            setquery((prev) => ({ ...prev, status: param, page: 1 }));
          }}
          searchPlaceholder="Search for amount..."
          hideExport
          moreComponents={
            <>
              <DateRangeComponent
                onSet={(param) => {
                  setquery((prev) => ({ ...prev, date: param, page: 1 }));
                }}
                value={query.date}
                onCancel={() => {
                  setquery((prev) => ({ ...prev, date: "", page: 1 }));
                }}
                // onOpen={}
              />
            </>
          }
        />

        <div className="table-section-box">
          <RazorTable headerList={headerList}>
            {ledger_record?.data?.map((chi: any, idx: any) => {
              return (
                <RazorTableRow
                  key={idx}
                  loading={loading}
                  one={
                    <RazorCopyText
                      textToCopy={chi?.reference}
                      reference={RazorTextTrim(chi?.reference, 28)}
                      outerCopy
                    />
                  }
                  two={<RazorDateTime date={chi?.created_at} />}
                  three={
                    <RazorBadgeTwo
                      className={
                        chi?.status === "failed"
                          ? "failed"
                          : chi?.status === "successful"
                            ? "success"
                            : chi?.status === "completed"
                              ? "success"
                              : chi?.status === "pending"
                                ? "pending"
                                : chi?.status === "processing"
                                  ? "pending"
                                  : chi?.status === "submitted"
                                    ? "pending"
                                    : ""
                      }
                      text={chi?.status}
                    />
                  }
                  four={chi?.account_type?.replace("_", " ") || "---"}
                  five={chi?.provider || "---"}
                  six={RazorNumberFormat(chi?.amount, {
                    symbol: chi?.currency,
                  })}
                  seven={
                    <div
                      onClick={() => {
                        if (user?.permissions?.includes(systemRoles[45])) {
                          localStorage?.setItem("cors_key", chi?.id);
                          navigate(ALL_ROUTES?.DASHBOARD_LEDGER_DETAILS);
                        }
                      }}
                    >
                      View details
                    </div>
                  }
                  // onRowClick={() => {
                  //   if (user?.permissions?.includes(systemRoles[45])) {
                  //     localStorage?.setItem("cors_key", chi?.id);
                  //     navigate(ALL_ROUTES?.DASHBOARD_LEDGER_DETAILS);
                  //   }
                  // }}
                />
              );
            })}
          </RazorTable>
        </div>
        <PaginationFragment
          currentPage={ledger_record?.meta?.current_page || 1}
          perPage={ledger_record?.meta?.per_page}
          totalPage={ledger_record?.meta?.total}
          onPageChange={(num) => {
            setquery((prev) => ({ ...prev, page: num }));
          }}
          hidePagination={loading}
          showPerPage
        />
      </main>
    </DashboardLayoutMain>
  );
}
